/**
 * The breadcrumb trail every intake page under a client starts with:
 * Clients › {client} › {Module} › Documents. The client crumb goes to the
 * client's module page, the module crumb to its hub, Documents to its library.
 * The client's name comes from the cached client read.
 *
 * `module` is the record's own (a file's) where the page has one; otherwise
 * the URL's.
 */
import { useClientQuery } from '../../queries/intake';
import type { Crumb } from '../../provider/pageTitle';
import { documentsCrumbs } from '../modules/flow';
import type { ModuleCode } from '../modules/modules';
import { useModule } from '../modules/useModule';

export function useClientCrumbs(
	clientId: string,
	module?: ModuleCode,
): Crumb[] {
	const client = useClientQuery(clientId);
	const { module: urlModule } = useModule();
	return documentsCrumbs(
		{ id: clientId, name: client.data?.name },
		module ?? urlModule,
	);
}
